import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "800px",
  },
  statistics: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& > span": {
      padding: "10px 30px",
      fontWeight: "bold",
      fontSize: "14px",
    },
  },
};
export const TeacherStatisticsSkeleton = () => (
  <Box sx={{ ...customStyles.statistics, gap: 10 }}>
    {[1, 2, 3].map((key) => (
      <Skeleton
        key={`teacher-skeleton-${key}`}
        variant="text"
        width={200}
        height={55}
      />
    ))}
  </Box>
);

export const StudentUsageSkeleton = () => (
  <TableContainer sx={customStyles.root}>
    <Table sx={{ width: "800px" }}>
      <TableBody>
        {[...Array(5)].map((_, rowIndex) => (
          <TableRow key={"skeleton-row-" + rowIndex}>
            {[...Array(4)].map((_, cellIndex) => (
              <TableCell key={`skeleton-cell-${rowIndex}-${cellIndex}`}>
                <Skeleton variant="text" width="100%" height={30} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
